import type { Page as TilelistPage } from '@shared/types/Tilelist';
import { getSegments } from '@tilelist/components/bottom-paging-bar/Segments';
import type {
    PaginationWithSegments,
    SegmentLink,
    Segments,
} from '@tilelist/components/bottom-paging-bar/Segments.types';
import { hasMoreThanOnePage } from '@tilelist/domain/composition/Pagination';
import { getComboPagination, getOffsetShift } from '@tilelist/domain/feature-visibility/ComboPagination';
import type { ComboIntentCounts } from '@tilelist/domain/feature-visibility/ComboPagination';

function shiftSegmentOffsets(segments: Segments, shift: number): Segments {
    if (shift === 0) return segments;
    const shiftLink = <T extends SegmentLink>(segment: T | undefined): T | undefined =>
        segment && { ...segment, offset: segment.offset > 0 ? segment.offset - shift : 0 };
    return {
        ...segments,
        segmentPreviousNavButton: shiftLink(segments.segmentPreviousNavButton),
        segmentFirstPage: shiftLink(segments.segmentFirstPage),
        segmentBeforePreviousPage: shiftLink(segments.segmentBeforePreviousPage),
        segmentPreviousPage: shiftLink(segments.segmentPreviousPage),
        segmentCurrentPage: {
            ...segments.segmentCurrentPage,
            offset: Math.max(segments.segmentCurrentPage.offset - shift, 0),
        },
        segmentNextPage: shiftLink(segments.segmentNextPage),
        segmentAfterNextPage: shiftLink(segments.segmentAfterNextPage),
        segmentLastPage: shiftLink(segments.segmentLastPage),
        segmentNextNavButton: shiftLink(segments.segmentNextNavButton),
    };
}

/**
 *
 *
 *
 *
 */
export function getComboPaginationWithSegments(counts: ComboIntentCounts, page: TilelistPage): PaginationWithSegments {
    const PER_PAGE = 120;
    const THRESHOLD = PER_PAGE / 2;
    const basePagination = getComboPagination(counts, page);
    const { currentOffset } = basePagination;
    const { rankedCount, sponsoredCount, pageItemCount, comboShown } = counts;
    const perPageWithSPA = PER_PAGE - sponsoredCount;
    const shift = getOffsetShift(currentOffset, perPageWithSPA, comboShown, pageItemCount);
    const itemCount = rankedCount + shift;
    const moreThanOnePage = hasMoreThanOnePage(
        { ...counts, rankedCount: pageItemCount === undefined ? itemCount : rankedCount },
        currentOffset,
    );
    const segments = moreThanOnePage
        ? shiftSegmentOffsets(
              getSegments({
                  offset: currentOffset > 0 ? currentOffset + shift : 0,
                  maxItemsPerPage: perPageWithSPA,
                  itemCount,
                  threshold: THRESHOLD,
              }),
              shift,
          )
        : undefined;

    return { ...basePagination, segments };
}
